const GlobalConstants = {
    Modes: {
        Upload: "UPLOAD",
        History: "HISTORY"
    }
};

module.exports = GlobalConstants;


// WEBPACK FOOTER //
// ./src/GlobalConstants.js